"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(6),
        [theme.breakpoints.up('md')]: {
            maxWidth: 'min(600px, 100%)',
            margin: '0 auto'
        }
    };
});
